import { useState } from 'react'
import { HelpCircle } from 'lucide-react'
import { useTourContext } from './TourContext'
import { TourMenu } from './TourMenu'

export function TourLauncher() {
  const [menuOpen, setMenuOpen] = useState(false)
  const { availableTours, progress, startTour, resetProgress, userRole } = useTourContext()

  const incompleteTours = availableTours.filter((t) => !progress[t.id]?.completed)

  const handleStartTour = (tourId: string) => {
    setMenuOpen(false)
    startTour(tourId)
  }

  return (
    <>
      <div className="fixed bottom-24 right-6 z-[9000]">
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="relative flex h-12 w-12 items-center justify-center rounded-full bg-primary-600 shadow-lg transition-colors hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
          aria-label="Open product tours"
          title="Product Tours"
        >
          <HelpCircle className="h-6 w-6 text-white" />
          {incompleteTours.length > 0 && (
            <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-[10px] font-bold text-white">
              {incompleteTours.length}
            </span>
          )}
        </button>
      </div>

      {menuOpen && (
        <>
          <div
            className="fixed inset-0 z-[8999]"
            onClick={() => setMenuOpen(false)}
            aria-hidden="true"
          />
          <TourMenu
            tours={availableTours}
            progress={progress}
            userRole={userRole}
            onStartTour={handleStartTour}
            onReset={resetProgress}
            onClose={() => setMenuOpen(false)}
          />
        </>
      )}
    </>
  )
}
